import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eccdced"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HotArticles" }
const _hoisted_2 = { class: "HotArticles-header" }
const _hoisted_3 = { class: "HotArticles-header-title" }
const _hoisted_4 = { class: "HotArticles-header-btn" }

import { reactive, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { getArticleListByType } from '@/apis/frog'
import { useRtfix, useSite } from '@/store'
import { useRouter } from 'vue-router'
import ArticleItem from './ArticleItem.vue'
import { getJapanTime as setStationTime } from '@/util/common'
import { Site } from '@/common/const'
import { TaEvent, taTrack } from '@/util/buryingPoint'

interface Item {
  'frogArticleId': string,
  'frogArticleTitle': string,
  'frogArticleSubTitle'?: string,
  'frogArticleType': number,
  'createTime': string,
  'viewNum': string,
  'frogArticleImgUrl': string,
  'frogArticleViewCount': string,
  'frogArticleEnableStatus': number,
  'stationCode': Site
}


export default /*#__PURE__*/_defineComponent({
  props: {
  // 标题
  title: {
    type: String,
    default: '热门文章'
  },
  // 获取文章条数
  size: {
    type: Number,
    default: 3
  },
  // 是否显示右侧按钮
  showBtn: {
    type: Boolean,
    default: true
  },
  // 是否显示列表空状态
  showEmpty: {
    type: Boolean,
    default: true
  },
  // item跳转方式 1-router.push跳转 2-变更url参数
  itemJumpWay: {
    type: String,
    default: '2'
  }
},
  setup(__props) {

const props = __props
const router = useRouter()



onMounted(() => {
  getList()
})

const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1
  }
})

// 获取列表
const getList = () => {
  const formData = {
    pageNum: data.page.currentPage,
    pageSize: props.size,
    typeList: Array.from({ length: 10 }, (v, i) => i + 1)
  }
  getArticleListByType(formData).then((res: any) => {
    // getHotList(formData).then((res: any) => {
    // console.log(res.data.records)
    if (res.code === '0') {
      data.list = res.data.records.map((item: Item) => ({
        ...item,
        createTime: item.frogArticleId === '151' ? '' : setStationTime(item.createTime)
      }))
    }
  })
}

// 跳转青蛙频道
const toKaerumedia = () => {
  // router.push(useRtfix('kaerumedia'))
  location.href = process.env.VUE_APP_HELP_URL + useSite()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(__props.title)), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_el_button, {
          class: "btn custom-plain",
          size: "large",
          round: "",
          onClick: toKaerumedia
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('更多最新文章')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, __props.showBtn]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "HotArticles-list",
      onClickCapture: _cache[0] || (_cache[0] = () => {
      _unref(taTrack)({
        event: _unref(TaEvent).BTN_CLICK,
        value: {
          position: 'community_article'
        }
      })
    })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
        return (_openBlock(), _createBlock(ArticleItem, {
          key: item.frogArticleId,
          item: item,
          itemJumpWay: __props.itemJumpWay
        }, null, 8, ["item", "itemJumpWay"]))
      }), 128)),
      (_unref(data).list.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            class: "HotArticles-list-empty",
            description: _unref(t)('没有更多了')
          }, null, 8, ["description"]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})